var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "850.39px",
    height: "850.39px",
    viewBox: "0 0 850.39 850.39",
    enableBackground: "new 0 0 850.39 850.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.407,348.901c0,20.398-16.534,36.935-36.938,36.935c-20.398,0-36.937-16.537-36.937-36.935 c0-20.401,16.539-36.938,36.937-36.938C451.873,311.963,468.407,328.5,468.407,348.901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.407,551.786c0,13.464-14.827,24.387-33.128,24.387h-11.96c-18.297,0-33.131-10.923-33.131-24.387V416.31 c0-13.47,14.834-24.388,33.131-24.388h11.96c18.301,0,33.128,10.918,33.128,24.388V551.786z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 573.952,
    y: 410.762,
    width: 243.787,
    height: 12.182
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "817.73,535.146 705.513,535.146 705.513,422.929  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "705.51,422.944 817.728,422.936 817.736,535.154  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "leftHand",
    d: "M569.39,419.515c0.001,8.158-6.614,14.773-14.771,14.773l-66.054-0.001 c-8.162,0.001-14.777-6.613-14.775-14.772l0,0c0-8.16,6.613-14.777,14.774-14.778h66.053 C562.775,404.738,569.39,411.355,569.39,419.515L569.39,419.515z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.873,
    y: 251.715,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 186.0397 592.6715)",
    width: 243.786,
    height: 12.182
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "45.932,255.264 125.282,334.614 204.632,255.264  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "204.623,255.277 125.279,175.921 45.923,255.265  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "rightHand",
    d: "M373.264,418.602c-5.766,5.77-15.122,5.768-20.893,0l-46.705-46.704c-5.773-5.775-5.772-15.13-0.005-20.898 l0,0c5.772-5.773,15.127-5.771,20.901,0.003l46.704,46.703C379.035,403.476,379.038,412.83,373.264,418.602L373.264,418.602z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgY);
export default __webpack_public_path__ + "static/media/y.3ca8c37519ddaeb191368aa56e5314fb.svg";
export { ForwardRef as ReactComponent };